import React, { useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';
import Modal from '../../../components/modal';
import * as XLSX from 'xlsx';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { API_URL } from '../../../utils/constant';
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import SalesBillModelReallocate from './sales_model';
import { getModulePermissions } from '../../../utils/getPermissions';
import { useLocation, useNavigate } from 'react-router-dom';
import ClaimModal from './claimmodel';
import ViewClaimModal from './view_claim_model';
import { Eye } from 'lucide-react';
import OldSalesBillModelReallocate from './old_product_reallocate';
import OtherClaimModal from './other_claim';
import { customTableStyles } from '../../../utils/tableStylings';
import BillFormatA4Page from '../pos/bills_format/format_a4';
import BillFormatA5Page from '../pos/bills_format/format_a5';
import BillFormat3mmPage from '../pos/bills_format/format_3mm';


const buildReceiptHTMLPDF = (args) => BillFormat3mmPage(args);


const buildReceiptExchangeHTML = ({ companyData, data }) => {
  const isSameState = companyData?.state === data.Customer?.state;

  const showOnBill = JSON.parse(companyData?.showOnBill || '{}');

  console.log(showOnBill, companyData);
  const oldTotal = data?.old_total || 0;
  const itemsHtml = data.product_data.map((item, idx) => {
    let html = '';
    const total = (item.amount || 0).toFixed(2);

    // Show old item only for the exchanged index
    if (idx === data.product_key) {
      html += `
          <tr style="border-top: 1px solid #eee;padding-top: 4px;">
            <td style="text-align:left;">Old Item: ${data?.product_remove.product_name.replace(/^[^-]+-/, '')}</td>
            <td style="text-align:center;">${data?.product_remove.qty}</td>
            <td style="text-align:right;">₹${data?.product_remove.amount}</td>
          </tr>
        `;
    }

    html += `
        <tr style="${idx === data.product_key ? 'border-bottom: 1px solid #eee;padding-bottom: 4px;' : ''}">
          <td style="text-align:left;">${idx === data.product_key ? 'Exchange Item: ' : ''} ${item.product_name}</td>
          <td style="text-align:center;">${item.qty}</td>
          <td style="text-align:right;">₹${total}</td>
        </tr>
      `;
    return html;
  }).join('');
  // ...existing code...

  return `
       <html>
         <head>
           <style>
             * { margin: 0; padding: 0; box-sizing: border-box; }
             body {
               font-family: monospace;
               font-size: 12px;
               width: 80mm;
               padding: 10px;
               color: #000;
             }
             h2, p { margin-bottom: 4px; }
             .center { text-align: center; }
             .bold { font-weight: bold; }
             table {
               width: 100%;
               border-collapse: collapse;
               margin-top: 10px;
             }
             td {
               padding: 4px 0;
             }
             .detail_tax {
               text-align: right;
             }
             .total {
               font-size: 14px;
               font-weight: bold;
               margin-top: 10px;
               text-align: right;
             }
             hr {
               border: none;
               border-top: 1px dashed #000;
               margin: 10px 0;
             }
             @media print {
               @page {
                 size: 80mm auto;
                 margin: 0;
               }
               body {
                 margin: 0;
                 padding: 3;
                 width: 80mm;
               }
             }
           </style>
         </head>
         <body >
           <div class="center">
             ${companyData?.posLogo ? `<img src="${API_URL}${companyData.posLogo}" width="100" style="display:block;margin:auto;"/>` : ''}
             ${showOnBill.companyName ? `<h2>${companyData?.company_name || 'Your Store'}</h2>` : ''}
             ${showOnBill.tradeName ? `<p>${companyData?.trade || ''}</p>` : ''}
             ${showOnBill.address ? `<p>${companyData?.city || ''}, ${companyData?.state || ''}</p>` : ''}
             ${showOnBill.contact ? `<p>${companyData?.mobile_no || ''}</p>` : ''}
             ${showOnBill.gstNo ? `<p>GSTIN: ${companyData?.gst_number || 'N/A'}</p>` : ''}
             ${showOnBill.pan ? `<p>PAN: ${companyData?.pan || ''}</p>` : ''}
             ${showOnBill.website ? `<p>${companyData?.website || ''}</p>` : ''}
             ${showOnBill.address ? `<p>${companyData?.register_address || ''}</p>` : ''}
             <p><strong>${data.bill_no || ''}</strong></p>
             <p>${moment(data.createdAt).format('DD MMM YYYY, hh:mm A')}</p>
           </div>
   
           <hr />
   
           ${data.Customer?.name ? `
             <p><strong>Customer:</strong> ${data.Customer.name}</p>
             <p><strong>Mobile:</strong> ${data.Customer.phone || '-'}</p>
           ` : ''}
   
           <table>
             <thead>
               <tr><td><b>Item</b></td><td><b>Qty</b></td><td><b>Total</b></td></tr>
             </thead>
             <tbody>
               ${itemsHtml}
             </tbody>
           </table>
   
           <hr />
   

          <p class="total" style="font-size: 10px;margin-bottom: 0px;">Old Total: ₹${oldTotal.toFixed(2)}</p>
          <p class="total" style="font-size: 10px;margin-bottom: 0px;">${oldTotal.toFixed(2) > data.total.toFixed(2) ? 'Refund Amount : ' : oldTotal.toFixed(2) < data.total.toFixed(2) ? 'Additional Amount : ' : 'No Price Changes'} ${oldTotal.toFixed(2) > data.total.toFixed(2) ? '₹' + (oldTotal.toFixed(2) - data.total.toFixed(2)) : oldTotal.toFixed(2) < data.total.toFixed(2) ? '₹' + (data.total.toFixed(2) - oldTotal.toFixed(2)) : ''}</p>
           <p class="total">Current Total: ₹${data.total.toFixed(2)} <br/> <small style="font-weight:100;font-size:8px;">(inclusive of all taxes)</small></p>

           <hr />

   
           ${showOnBill.footerStatement ? `<div class="left">${(companyData?.footer_statement || '').split(/\r?\n/).map(line => line ? `<div>${line}</div>` : '<br/>').join('')}</div>` : ''}
          <p class="center">Please Visit again</p>
         </body>
       </html>
     `;
};

const SalesBillsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const bill_id = query.get("bill");

  const handleEditDraft = (bill) => {
    navigate(`/pos?draft_id=${bill.id}`, { state: { editDraftBill: bill } });
  };
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState([]);
  const [search, setSearch] = useState('');
  const [showReallocateModalold, setShowReallocateModalOld] = useState(false);
  const [showReallocateModal, setShowReallocateModal] = useState(false);
  const [reallocateBill, setReallocateBill] = useState(null);
  const [showClaimModal, setShowClaimModal] = useState(false);
  const [showOldClaimModal, setShowOldClaimModal] = useState(false);
  const [claimBill, setClaimBill] = useState(null);
  const [showViewClaimModal, setShowViewClaimModal] = useState(false);
  const [viewClaimData, setViewClaimData] = useState(null);
  const [showDispenseModal, setShowDispenseModal] = useState(false);
  const [selectedDispenseMaterials, setSelectedDispenseMaterials] = useState([]);
  const [dispenseBillNo, setDispenseBillNo] = useState("");
  const [showProductsModal, setShowProductsModal] = useState(false);
  const [selectedProductsBill, setSelectedProductsBill] = useState(null);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [productType, setProductType] = useState(""); // new | old
  const [oldType, setOldType] = useState(""); // AB-OS | AB-SS



  useEffect(() => {
    if (productType !== "old") {
      setOldType("");
    }
  }, [productType]);

  const fetchCompany = async (companyId) => {
    try {
      const res = await axios.get(`${API_URL}/companies/${companyId}`);
      const data = res.data;
      setCompanyData(data);
    } catch (err) {
      console.error("Failed to fetch company:", err);
    }
  };

  const fetchBills = async () => {
    try {
      setLoading(true);
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;

      const response = await axios.get(`${API_URL}/bills/sales-bills/${companyId}`);
      if (response.data.success) {
        setBills(response.data.data);
      } else {
        console.error('Failed to fetch bills');
      }
      fetchCompany(companyId);
    } catch (err) {
      console.error('Error fetching bills:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBills();
  }, []);

  const handlePrint = async (bill) => {
    const result = await Swal.fire({
      title: 'Choose Print Layout',
      text: 'Do you want to print with the header or without the header?',
      icon: 'question',
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: 'With Header',
      denyButtonText: 'Without Header',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#5c636a',
    });

    if (result.isDismissed) return;

    const withHeader = result.isConfirmed; // true if 'With Header', false if 'Without Header' (isDenied)

    let html = '';
    if (bill.bill_type === 'Wholesale') {
      html = BillFormatA4Page({ companyData: companyData, data: bill, withHeader });
    } else {
      html = BillFormatA5Page({ companyData: companyData, data: bill, withHeader });
    }
    const newWin = window.open('', '_blank');
    newWin.document.write(html);
    newWin.document.close();
    newWin.onload = () => {
      const images = newWin.document.images;
      let loadedCount = 0;

      const handleLoadOrError = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          // printWindow.focus();
          // printWindow.print();
        }
      };

      for (let img of images) {
        img.onload = handleLoadOrError;
        img.onerror = handleLoadOrError;
      }

      newWin.focus();
      newWin.print();
      newWin.close();
    };
  };

  const handlePrintReceipt = (bill) => {
    const html = buildReceiptHTMLPDF({ companyData: companyData, data: bill });
    const newWin = window.open('', '_blank');
    newWin.document.write(html);
    newWin.document.close();
    newWin.onload = () => {
      newWin.focus();
      newWin.print();
      newWin.close();
    };
  };

  const handlePrintExchange = async (bill) => {
    const result = await Swal.fire({
      title: 'Choose Print Layout',
      text: 'Do you want to print with the header or without the header?',
      icon: 'question',
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: 'With Header',
      denyButtonText: 'Without Header',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#5c636a',
    });

    if (result.isDismissed) return;

    const withHeader = result.isConfirmed; // true if 'With Header', false if 'Without Header' (isDenied)

    const html = BillFormatA4Page({ companyData: companyData, data: bill, withHeader });
    // const html = buildReceiptExchangeHTML({ companyData: companyData, data: bill });
    const newWin = window.open('', '_blank');
    newWin.document.write(html);
    newWin.document.close();
    newWin.onload = () => {
      const images = newWin.document.images;
      let loadedCount = 0;

      const handleLoadOrError = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          // printWindow.focus();
          // printWindow.print();
        }
      };

      for (let img of images) {
        img.onload = handleLoadOrError;
        img.onerror = handleLoadOrError;
      }

      newWin.focus();
      newWin.print();
      newWin.close();
    };
  };

  const handleDownloadPDF = async (bill) => {
    const result = await Swal.fire({
      title: 'Choose Layout',
      text: 'Do you want to generate the PDF with the header or without the header?',
      icon: 'question',
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: 'With Header',
      denyButtonText: 'Without Header',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#5c636a',
    });

    if (result.isDismissed) return;

    const withHeader = result.isConfirmed; // true if 'With Header', false if 'Without Header' (isDenied)
    const isWholesale = bill.bill_type === 'Wholesale';

    let html = '';
    if (isWholesale) {
      html = BillFormatA4Page({ companyData: companyData, data: bill, withHeader });
    } else {
      html = BillFormatA5Page({ companyData: companyData, data: bill, withHeader });
    }

    // Create a new window
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    // Write content to new window
    printWindow.document.write(html);
    printWindow.document.close();

    // Wait for new window to load
    printWindow.onload = () => {
      const element = printWindow.document.body;

      html2pdf()
        .from(element)
        .set({
          margin: 0,
          filename: `${bill.bill_no || 'receipt'}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            allowTaint: true
          },
          jsPDF: {
            unit: 'mm',
            format: isWholesale ? 'a4' : 'a5',
            orientation: isWholesale ? 'portrait' : 'landscape'
          }
        })
        .save()
        .then(() => {
          printWindow.close();
        });
    };
  };

  const openViewClaimModal = (bill) => {
    setShowViewClaimModal(true);
    setViewClaimData(bill.Claim);
  };


  const openClaimModal = (bill) => {
    setShowClaimModal(true);
    setClaimBill(bill);
  };


  const openOldClaimModal = (bill) => {
    setShowOldClaimModal(true);
    setClaimBill(bill);
  };

  const handleClaimSubmit = async (claimData) => {
    try {
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;

      const response = await axios.post(`${API_URL}/pos/claim/create`, {
        ...claimData,
        company_id: companyId
      });

      if (response.data.status) {
        Swal.fire(
          'Claim Submitted!',
          `Claim has been recorded. Type: ${claimData.type === 'exchange' ? 'Exchange' : 'Money Back'}`,
          'success'
        );
        setShowClaimModal(false);
        window.location.reload();
        fetchBills(); // Refresh bills
      } else {
        Swal.fire('Error!', response.data.message || 'Failed to process claim.', 'error');
      }
    } catch (err) {
      Swal.fire('Error!', 'Error processing claim.', 'error');
      console.error(err);
    }
  };


  const handleDelete = async (row) => {
    try {
      // Make API call to delete the record
      const response = await axios.delete(`${API_URL}/bills/sales-bills/${row.id}`); // replace with your endpoint

      if (response.status === 200) {
        // Update local state to remove deleted row
        setBills(prev => prev.filter(item => item.id !== row.id));

        Swal.fire("Deleted!", "The record has been deleted successfully.", "success");
      } else {
        Swal.fire("Error!", "Something went wrong. Please try again.", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error!", "Failed to delete the record.", "error");
    }
  };


  const columns = [
    {
      name: '#',
      cell: (row, index) => index + 1,
      width: '50px'
    },
    {
      name: 'Bill Type',
      selector: row => row.bill_type,
    },
    {
      name: 'Bill No',
      selector: row => row.bill_no,
      sortable: true
    },
    {
      name: 'Bill For',
      selector: row => row.bill_for,
      sortable: true
    },
    {
      name: 'Customer',
      cell: row => (
        <div style={{ display: 'block' }}>
          <div ><strong>{row.Customer?.name || 'N/A'}</strong></div>
          <div className="text-muted">{row.Customer?.phone || '-'}</div>
        </div>
      )
    },
    {
      name: "Products",
      grow: 2,
      width: "320px",
      cell: row => {
        const productList = row.product_data || [];
        const displayLimit = 2;
        const displayProducts = productList.slice(0, displayLimit);
        const remainingCount = productList.length - displayLimit;

        return (
          <div
            style={{
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              paddingRight: "4px",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: "100%"
            }}
          >
            {displayProducts.map((p, i) => (
              <div
                key={i}
                className="border rounded p-2 bg-primary text-white"
                style={{ fontSize: "12px" }}
              >
                {/* Product name & Qty */}
                <div
                  className="fw-bold text-white d-flex justify-content-between align-items-start"
                  title={p.product_name}
                  style={{
                    maxWidth: "100%",
                    marginBottom: "4px",
                    whiteSpace: "normal",
                    lineHeight: "1.2"
                  }}
                >
                  <span>
                    {p.product_name}
                    {(p.product_type === "AB-OS" || p.product_type === "AB-SS") && (
                      <span className="ms-1 text-warning">({p.product_type})</span>
                    )}
                  </span>
                  <span className="badge bg-white text-primary font-bold ms-2" style={{ minWidth: "50px", flexShrink: 0 }}>Qty: {p.qty}</span>
                </div>

                {/* Serial numbers */}
                {p.serial_nos && p.serial_nos.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "4px"
                    }}
                  >
                    {p.serial_nos.map((s, j) => (
                      <span
                        key={j}
                        className="badge bg-white border text-dark"
                        style={{ fontSize: "10px" }}
                      >
                        {s.serial_no}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            ))}

            {remainingCount > 0 && (
              <button
                type="button"
                className="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center gap-1 w-100 py-1 mt-1 shadow-sm"
                style={{ fontSize: "11px", fontWeight: "600" }}
                onClick={() => {
                  setSelectedProductsBill(row);
                  setShowProductsModal(true);
                }}
              >
                <Eye size={13} />
                <span>+{remainingCount} More {remainingCount === 1 ? 'Product' : 'Products'}</span>
              </button>
            )}
          </div>
        );
      }
    },
    {
      name: 'Dispense Materials',
      cell: row => {
        const hasDispenseMaterials = row.product_data.some(p => p.dispense_materials && p.dispense_materials.length > 0);
        return (
          <div className="d-flex justify-content-center w-100">
            {hasDispenseMaterials ? (
              <button
                className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                onClick={() => {
                  setDispenseBillNo(row.bill_no);
                  setSelectedDispenseMaterials(row.product_data);
                  setShowDispenseModal(true);
                }}
              >
                <Eye size={14} />
                <span>View</span>
              </button>
            ) : (
              <span className="text-muted small">-</span>
            )}
          </div>
        );
      },
      width: '150px',
      center: true
    },
    {
      name: 'Discount',
      selector: row => `₹${(row.discountAmount || 0).toFixed(2)}`,
      right: true
    },
    {
      name: 'Total',
      selector: row => `₹${(row.total || 0).toFixed(2)}`,
      right: true
    },
    {
      name: 'Date',
      selector: row => moment(row.createdAt).format('DD-MM-YYYY hh:mm A'),
      sortable: true
    },
    {
      name: 'Is Draft',
      sortable: true,
      cell: row => (
        row.isDraft == '10' ? (
          <span className="badge bg-danger fs-12">Claimed</span>
        ) : row.isDraft == '1' ? (
          <span className="badge bg-warning text-dark fs-12">Draft</span>
        ) : row.isDraft == '2' ? (
          <span className="badge bg-danger text-white fs-12">Cancelled</span>
        ) : row.isDraft == '3' ? (
          <span className="badge bg-info text-white fs-12">Exchange</span>
        ) : (
          <span className="badge bg-success fs-12">Completed</span>
        )
      )
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex gap-2">
          {row.isDraft == '1' && (
            <>
              <button className="btn btn-sm btn-outline-warning" onClick={() => handleEditDraft(row)}>
                <i className="ti ti-edit fs-14 me-1"></i>Edit Draft
              </button>
              <button className="btn btn-sm btn-outline-success" onClick={() => handleCompletePurchasee(row)}>
                Complete Purchase
              </button>
            </>
          )}
          {(row.isDraft != '2' && row.isDraft != '1') && (<button className="btn btn-sm btn-outline-danger" onClick={() => handleRestock(row)}>Cancel Bill</button>)}
          <button className="btn btn-sm btn-outline-secondary" onClick={() => handlePrint(row)}>Print</button>
          <button className="btn btn-sm btn-outline-info" onClick={() => handleDownloadPDF(row)}>PDF</button>
          <button className="btn btn-sm btn-outline-dark" onClick={() => handlePrintReceipt(row)}>Receipt</button>
          {((row.isDraft != '10' && row.isDraft != '1' && row.isDraft != '2' && row.isDraft != '3') && (row.is_other != 1)) && (<button className="btn btn-sm btn-outline-primary" onClick={() => openReallocateModal(row)}>Exchange</button>)}
          {((row.isDraft != '10' && row.isDraft != '1' && row.isDraft != '2' && row.isDraft != '3') && row.is_other == 1) && (<button className="btn btn-sm btn-outline-primary" onClick={() => openOldReallocateModal(row)}>Exchange</button>)}
          {((row.isDraft != '10' && row.isDraft != '1' && row.isDraft != '2' && row.isDraft != '3') && row.is_other != 1) && (<button className="btn btn-sm btn-outline-warning" onClick={() => openClaimModal(row)}>Claim</button>)}
          {((row.isDraft != '10' && row.isDraft != '1' && row.isDraft != '2' && row.isDraft != '3') && row.is_other == 1) && (<button className="btn btn-sm btn-outline-warning" onClick={() => openOldClaimModal(row)}>Claim</button>)}
          {(row.isDraft == '0' && row.Claim != null) && (<button className="btn btn-sm btn-outline-warning" onClick={() => openViewClaimModal(row)}>View Claim</button>)}
          {row.isDraft == '3' && (<button className="btn btn-sm btn-outline-primary" onClick={() => handlePrintExchange(row)}>Print Exchange</button>)}

          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this record!",
                icon: "warning",
                showCancelButton: true, // Show Cancel button
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "Cancel",
                reverseButtons: true, // Optional: swaps positions of buttons
              }).then((result) => {
                if (result.isConfirmed) {
                  handleDelete(row); // call your delete function
                  // Swal.fire("Deleted!", "The record has been deleted.", "success");
                }
              });
            }}
          >
            Delete
          </button>
        </div>
      ),
      width: '500px'
    }
  ];
  // Re-Allocate Modal State


  // Open modal handler
  const openReallocateModal = (bill) => {
    setShowReallocateModal(true);
    setReallocateBill(bill);
  };

  const openOldReallocateModal = (bill) => {
    setShowReallocateModalOld(true);
    setReallocateBill(bill);
  };

  // Search products API
  const handleRestock = async (bill) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to cancel this bill and restock the items?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, cancel & restock',
      cancelButtonText: 'No',
    });
    if (!result.isConfirmed) return;
    try {
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;
      if (bill.is_other == 1) {
        const response = await axios.post(`${API_URL}/bills/sales-bills/restock-old/${companyId}`, {
          bill_id: bill.id
        });
        if (response.data.message == 'Bill cancelled successfully') {
          Swal.fire('Restocked!', 'Bill cancelled and items restocked.', 'success');
        } else {
          Swal.fire('Failed!', 'Restock failed.', 'error');
        }
      } else {
        const response = await axios.post(`${API_URL}/bills/sales-bills/restock/${companyId}`, {
          bill_id: bill.id
        });
        if (response.data.message == 'Bill cancelled successfully') {
          Swal.fire('Restocked!', 'Bill cancelled and items restocked.', 'success');
        } else {
          Swal.fire('Failed!', 'Restock failed.', 'error');
        }
      }

    } catch (err) {
      Swal.fire('Error!', 'Error during restock.', 'error');
      console.error(err);
    } finally {
      window.location.reload();
    }
  };

  // Search products API
  const handleCompletePurchasee = async (bill) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to Complete this bill purchase?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Complete purchase',
      cancelButtonText: 'No',
    });
    if (!result.isConfirmed) return;
    try {
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;
      const response = await axios.post(`${API_URL}/bills/sales-bills/complete/${companyId}`, {
        bill_id: bill.id
      });
      if (response.data.message == 'Items restocked successfully') {
        Swal.fire('Complete!', 'Bill Purchase Completed', 'success');
      } else {
        Swal.fire('Failed!', 'Something went wrong.', 'error');
      }
    } catch (err) {
      Swal.fire('Error!', 'Error during restock.', 'error');
      console.error(err);
    } finally {
      window.location.reload();
    }
  };

  // Filter bills by search (now includes customer name and phone)
  // Filter bills by search (now includes customer name and phone)
  const filteredBills = bills.filter(bill => {
    // If bill_id is provided, only return that specific bill
    if (bill_id) {
      console.log(bill.bill_no.toLowerCase(), bill_id.toLowerCase());
      return bill.bill_no.toLowerCase() == `${bill_id.toLowerCase()}`;
    }

    const searchTerm = search.toLowerCase();

    // If no search term, return all bills
    if (!searchTerm) {
      return true;
    }

    // Check bill_no, order_no
    if ((bill.bill_no && bill.bill_no.toLowerCase().includes(searchTerm)) ||
      (bill.order_no && bill.order_no.toLowerCase().includes(searchTerm))) {
      return true;
    }

    // Check customer name and phone
    if (bill.Customer && (
      (bill.Customer.name && bill.Customer.name.toLowerCase().includes(searchTerm)) ||
      (bill.Customer.phone && bill.Customer.phone.toLowerCase().includes(searchTerm))
    )) {
      return true;
    }

    // Check product_name, color, size, serial_no in product_data
    if (bill.product_data && bill.product_data.some(p =>
      (p.product_name && p.product_name.toLowerCase().includes(searchTerm)) ||
      (p.color && p.color.toLowerCase().includes(searchTerm)) ||
      (p.size && p.size.toLowerCase().includes(searchTerm)) ||
      (p.serial_nos && p.serial_nos.some(s => s.serial_no && s.serial_no.toLowerCase().includes(searchTerm)))
    )) {
      return true;
    }

    return false;
  });

  // Excel Export Handler
  const handleExportExcel = () => {
    Swal.fire({
      title: 'Export Excel',
      text: 'Do you want to export bills for a specific date range?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, select range',
      cancelButtonText: 'No, export all',
    }).then(async (result) => {
      let billsToExport = filteredBills;
      if (result.isConfirmed) {
        const { value: formValues } = await Swal.fire({
          title: 'Select Date Range',
          html:
            '<div class="d-flex gap-2">' +
            '<input id="swal-input1" type="date" class="swal2-input" placeholder="Start Date">' +
            '<input id="swal-input2" type="date" class="swal2-input" placeholder="End Date">' +
            '</div>',
          focusConfirm: false,
          preConfirm: () => {
            return [
              document.getElementById('swal-input1').value,
              document.getElementById('swal-input2').value
            ];
          }
        });
        if (formValues && formValues[0] && formValues[1]) {
          const startDate = moment(formValues[0], 'YYYY-MM-DD').startOf('day');
          const endDate = moment(formValues[1], 'YYYY-MM-DD').endOf('day');
          billsToExport = filteredBills.filter(bill => {
            const billDate = moment(bill.createdAt);
            return billDate.isBetween(startDate, endDate, null, '[]');
          });
        }
      }
      // Filter out bills where any product_name contains 'demo'
      const filteredBillsToExport = billsToExport.filter(bill =>
        !bill.product_data.some(p =>
          p.product_name && p.product_name.toLowerCase().includes('demo')
        )
      );
      // Prepare data for Excel
      const excelData = filteredBillsToExport.map(bill => ({
        'Bill No': bill.bill_no,
        'Order No': bill.order_no,
        'Customer Name': bill.Customer?.name || '',
        'Customer Phone': bill.Customer?.phone || '',
        'Products': bill.product_data.map(p => {
          let str = `${p.product_name} (Qty: ${p.qty})`;
          if (p.dispense_materials && p.dispense_materials.length > 0) {
            const mats = p.dispense_materials.map(m => `${m.name}: ${m.qty}`).join(', ');
            str += ` [Materials: ${mats}]`;
          }
          return str;
        }).join(', '),
        'Total': bill.total,
        'Date': moment(bill.createdAt).format('DD-MM-YYYY'),
        'Time': moment(bill.createdAt).format('hh:mm A'),
        'Is Draft': bill.isDraft == '1' ? 'Draft' : 'Completed',
        'Mode of Payment': bill.mode_of_payment || '',
        'Cash': bill.cash || '',
        'Return': bill.returned || ''
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'SalesBills');
      XLSX.writeFile(workbook, 'SalesBills.xlsx');
    });
  };

  const filteredData = useMemo(() => {
    return filteredBills.filter(item => {
      const created = new Date(item.createdAt);

      /* DATE RANGE */
      if (fromDate && created < new Date(fromDate)) return false;

      if (toDate) {
        const end = new Date(toDate);
        end.setHours(23, 59, 59, 999);
        if (created > end) return false;
      }

      /* PRODUCT TYPE */
      if (productType) {
        if (productType === "new" && Number(item.is_other) !== 0) return false;
        if (productType === "old" && Number(item.is_other) !== 1) return false;
      }

      /* OLD TYPE */
      if (productType === "old" && oldType && item.old_type !== oldType) return false;

      return true;
    });
  }, [filteredBills, fromDate, toDate, productType, oldType]);




  return (
    <>
      <div className='card'>
        <div className='card-header d-flex justify-content-between align-items-center flex-wrap gap-2'>
          <h3 className='text-primary mb-0'>Sales Bills</h3>
          <div className="d-flex align-items-end gap-2 flex-wrap">

            {/* SEARCH */}
            <div className='position-relative flex-grow-1' style={{ minWidth: "200px" }}>
              <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                Search
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Bill No, Order No, Product, Serial, Color, Size..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>

            {/* FROM DATE */}
            <div className='position-relative '>
              <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                From Date
              </span>
              <input
                type="date"
                className="form-control"
                value={fromDate || ""}
                onChange={e => setFromDate(e.target.value)}
              />
            </div>

            {/* TO DATE */}
            <div className='position-relative'>
              <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                To Date
              </span>
              <input
                type="date"
                className="form-control"
                value={toDate || ""}
                onChange={e => setToDate(e.target.value)}
              />
            </div>

            {/* PRODUCT TYPE */}
            <div className='position-relative'>
              <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                Product Type
              </span>
              <select
                className="form-select"
                value={productType}
                onChange={e => setProductType(e.target.value)}
              >
                <option value="">All</option>
                <option value="new">Existing Products</option>
                <option value="old">Old Products</option>
              </select>
            </div>

            {/* OLD TYPE */}
            {/* {productType === "old" && (
              <div>
                <label className="form-label small">Old Type</label>
                <select
                  className="form-select"
                  value={oldType}
                  onChange={e => setOldType(e.target.value)}
                >
                  <option value="">All</option>
                  <option value="AB-OS">AB-OS</option>
                  <option value="AB-SS">AB-SS</option>
                </select>
              </div>
            )} */}

            {/* RESET */}
            <div>
              <button
                className="btn btn-danger"
                onClick={() => {
                  setSearch("");
                  setFromDate(null);
                  setToDate(null);
                  setProductType("");
                  setOldType("");
                }}
              >
                Reset
              </button>
            </div>

            {/* EXPORT */}
            {getModulePermissions({ module: 'Accounts', type: 'Sales Bill Export' }) && (
              <div>
                <button
                  className="btn btn-success"
                  type="button"
                  onClick={handleExportExcel}
                >
                  Export Excel
                </button>
              </div>
            )}
          </div>
        </div>
        <div className='card-body'>
          <DataTable
            columns={columns}
            data={filteredData}
            progressPending={loading}
            pagination
            highlightOnHover
            striped
            responsive
            customStyles={customTableStyles}
          />
        </div>
      </div>
      <SalesBillModelReallocate
        show={showReallocateModal}
        onClose={() => setShowReallocateModal(false)}
        heading={'Re-Allocate Product'}
        initialData={reallocateBill}
      />

      <OldSalesBillModelReallocate
        show={showReallocateModalold}
        onClose={() => setShowReallocateModalOld(false)}
        heading={'Re-Allocate Product'}
        initialData={reallocateBill}
      />


      <ClaimModal
        show={showClaimModal}
        onClose={() => setShowClaimModal(false)}
        bill={claimBill}
        onSubmit={handleClaimSubmit}
      />
      <OtherClaimModal
        show={showOldClaimModal}
        onClose={() => setShowOldClaimModal(false)}
        bill={claimBill}
        onSubmit={handleClaimSubmit}
      />

      <ViewClaimModal
        show={showViewClaimModal}
        onClose={() => setShowViewClaimModal(false)}
        claim={viewClaimData}
      />

      <Modal
        show={showDispenseModal}
        onClose={() => setShowDispenseModal(false)}
        heading={`Dispense Materials for Bill: ${dispenseBillNo}`}
        size="lg"
      >
        <div className="table-responsive">
          <table className="table table-bordered table-striped align-middle">
            <thead>
              <tr className="bg-primary text-white">
                <th>Product Name</th>
                <th className="text-center" style={{ width: "110px" }}>Qty Sold</th>
                <th>Dispense Materials</th>
              </tr>
            </thead>
            <tbody>
              {selectedDispenseMaterials.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center text-muted py-3">
                    No dispense materials recorded for this bill.
                  </td>
                </tr>
              ) : (
                selectedDispenseMaterials.map((p, idx) => (
                  <tr key={idx}>
                    <td className="fw-semibold text-dark">{p.product_name}</td>
                    <td className="text-center">
                      <span className="badge bg-secondary">Qty: {p.qty}</span>
                    </td>
                    <td>
                      {p.dispense_materials && p.dispense_materials.length > 0 ? (
                        <div className="d-flex flex-column gap-2">
                          {p.dispense_materials.map((m, mIdx) => (
                            <div key={mIdx} className="d-flex justify-content-between align-items-center bg-light p-2 rounded border">
                              <span className="fw-medium text-secondary">• {m.name}</span>
                              <span className="badge bg-primary text-white font-bold ms-2">Qty: {m.qty}</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span className="text-muted small">None</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Modal>

      {/* All Products Modal */}
      <Modal
        show={showProductsModal}
        onClose={() => setShowProductsModal(false)}
        heading={`Products List - Bill: ${selectedProductsBill?.bill_no || ''}`}
        size="lg"
      >
        {selectedProductsBill && (
          <div>
            <div className="d-flex flex-wrap justify-content-between align-items-center bg-light p-3 rounded mb-3 border">
              <div>
                <strong>Customer: </strong> {selectedProductsBill.Customer?.name || 'Walk-in Customer'}
                {selectedProductsBill.Customer?.phone && ` (${selectedProductsBill.Customer.phone})`}
              </div>
              <div>
                <strong>Date: </strong> {moment(selectedProductsBill.createdAt).format('DD-MM-YYYY hh:mm A')}
              </div>
              <div>
                <strong>Total: </strong> <span className="text-primary fw-bold">₹{(selectedProductsBill.total || 0).toFixed(2)}</span>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle mb-0">
                <thead className="table-primary">
                  <tr>
                    <th style={{ width: "40px" }} className="text-center">#</th>
                    <th>Product Description</th>
                    <th style={{ width: "90px" }} className="text-center">Qty</th>
                    <th style={{ width: "110px" }} className="text-end">Price / Rate</th>
                    <th style={{ width: "120px" }} className="text-end">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedProductsBill.product_data?.map((p, idx) => (
                    <tr key={idx}>
                      <td className="text-center fw-semibold">{idx + 1}</td>
                      <td>
                        <div className="fw-bold text-dark">
                          {p.product_name}
                          {(p.product_type === "AB-OS" || p.product_type === "AB-SS") && (
                            <span className="badge bg-warning text-dark ms-2">{p.product_type}</span>
                          )}
                        </div>
                        {p.batch_no && (
                          <div className="text-muted small mt-1">Batch: <span className="fw-semibold">{p.batch_no}</span></div>
                        )}
                        {p.serial_nos && p.serial_nos.length > 0 && (
                          <div className="d-flex flex-wrap gap-1 mt-1">
                            {p.serial_nos.map((s, j) => (
                              <span key={j} className="badge bg-light border text-dark" style={{ fontSize: "10px" }}>
                                {s.serial_no}
                              </span>
                            ))}
                          </div>
                        )}
                        {p.dispense_materials && p.dispense_materials.length > 0 && (
                          <div className="mt-1 small text-secondary">
                            <span className="fw-semibold">Dispense: </span>
                            {p.dispense_materials.map((m, mIdx) => (
                              <span key={mIdx} className="badge bg-info text-dark me-1">
                                {m.name} (Qty: {m.qty})
                              </span>
                            ))}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        <span className="badge bg-primary text-white font-bold px-2 py-1">
                          {p.qty}
                        </span>
                      </td>
                      <td className="text-end text-muted">
                        ₹{(parseFloat(p.price) || 0).toFixed(2)}
                      </td>
                      <td className="text-end fw-bold text-dark">
                        ₹{(parseFloat(p.amount || (parseFloat(p.price || 0) * parseFloat(p.qty || 0))) || 0).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>

    </>
  );
};

export default SalesBillsPage;
